import React, { useState, useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useTranslation } from 'react-i18next';
const references = [
  { image: "https://www.remora.com.tr/wp-content/uploads/2025/05/ref1.png" },
  { image: "https://www.remora.com.tr/wp-content/uploads/2025/05/ref2.png" },
  { image: "https://www.remora.com.tr/wp-content/uploads/2025/05/ref3.png" },
  { image: "https://www.remora.com.tr/wp-content/uploads/2025/05/ref4.png" },
  { image: "https://www.remora.com.tr/wp-content/uploads/2025/05/ref5.png" },
  { image: "https://www.remora.com.tr/wp-content/uploads/2025/05/ref6.png" },
  { image: "https://www.remora.com.tr/wp-content/uploads/2025/05/ref7.png" },
  { image: "https://www.remora.com.tr/wp-content/uploads/2025/05/ref8.png" },
  { image: "https://www.remora.com.tr/wp-content/uploads/2025/05/ref9.png" },
  { image: "https://www.remora.com.tr/wp-content/uploads/2025/05/ref10.png" },
  { image: "https://www.remora.com.tr/wp-content/uploads/2025/05/ref11.png" },
  { image: "https://www.remora.com.tr/wp-content/uploads/2025/05/ref12.png"},
];

const References = () => {
  const { t, i18n } = useTranslation();
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobileView(window.innerWidth <= 600); // 600px ve altı mobil olarak kabul edilir
    };

    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);
    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  return (
    <Box
    sx={{
      py: 5,
      backgroundColor: "white",
      textAlign: "center",
    }}
  >
    <Typography
      variant="h4"
      sx={{
        fontWeight: 700,
        fontSize: { xs: "1.8rem", md: "2.4rem" },
        color: "#000000",
        mb: 3,
      }}
    >
     {t('home.title')} 
    </Typography>
  
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap", // Esnek düzen için wrap ekledim
        justifyContent: "center",
        gap: 4,
        padding: "10px 0",
        overflow: "hidden", // Fazla kaydırmayı engelle
      }}
    >
      {references.map((reference, index) => (
        <motion.div
          key={index}
          whileHover={{ scale: 1.1 }}
          transition={{ duration: 0.3 }}
        >
          <Box
            component="img"
            src={reference.image}
            alt={`Reference ${index + 1}`}
            sx={{
              width: { xs: "60px", md: "120px" }, // Mobilde 60px, webde 120px
              height: "auto",
              objectFit: "contain",
              opacity: 0.8,
              transition: "opacity 0.3s",
              "&:hover": { opacity: 1 },
            }}
          />
        </motion.div>
      ))}
    </Box>
  </Box>
  
  );
};

export default References;
